/**
 * A file size as the Files table shows it (`28 KB`, `0 B`), with locale
 * digits. A leaf module so the app-wide upload panel can use it cheaply.
 */
export function formatWorkspaceFileSize(
  sizeBytes: number | undefined,
  // Callers without the app locale keep the previous "7.0 MB" output.
  locale = 'en'
): string | null {
  if (typeof sizeBytes !== 'number' || !Number.isFinite(sizeBytes)) return null;
  if (sizeBytes < 1024) return `${formatSizeNumber(sizeBytes, 0, locale)} B`;
  const units = ['KB', 'MB', 'GB'];
  let value = sizeBytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${formatSizeNumber(value, value >= 10 ? 0 : 1, locale)} ${units[unitIndex]}`;
}
/** Locale digits and decimal separator ("7,0" in de) with fixed precision. */
function formatSizeNumber(
  value: number,
  fractionDigits: number,
  locale: string
): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping: false,
  }).format(value);
}
